export default "__VITE_ASSET__DWN6cpVg__"